import React from 'react';
import AceEditor from 'react-ace';
import Button from '@mui/material/Button';

import "ace-builds/src-noconflict/mode-xml";
import "ace-builds/src-noconflict/theme-monokai";

const SNIPPETS = [
    {
        label: 'mj-text',
        snippet: '<mj-text>Your text here</mj-text>',
    },
    {
        label: 'mj-button',
        snippet: '<mj-button href="#">Click Here</mj-button>',
    },
    {
        label: 'mj-image',
        snippet: '<mj-image src="https://placehold.co/600x100" width="600px" />',
    },
    {
        label: 'mj-divider',
        snippet: '<mj-divider border-color="#cccccc" border-width="1px" />',
    },
    {
        label: 'mj-spacer',
        snippet: '<mj-spacer height="20px" />',
    },
    {
        label: 'mj-social',
        snippet: `<mj-social font-size="15px" icon-size="30px" mode="horizontal">
  <mj-social-element name="facebook" href="#">Facebook</mj-social-element>
  <mj-social-element name="twitter" href="#">Twitter</mj-social-element>
</mj-social>`,
    },
];

const MjmlEditor = ({ id, mjml, onChange }) => {
    const editorRef = React.useRef(null);

    function onLoad(editor) {
        editorRef.current = editor;
    }

    function handleInsert(snippet) {
        const editor = editorRef.current;
        if (editor) {
            editor.session.insert(editor.getCursorPosition(), snippet);
            editor.focus();
        }
    }

    return (
        <div>
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4, marginBottom: 6 }}>
                {SNIPPETS.map(({ label, snippet }) => (
                    <Button
                        key={label}
                        size="small"
                        variant="outlined"
                        color="secondary"
                        onClick={() => handleInsert(snippet)}
                        style={{ fontSize: 10, padding: '2px 6px', minWidth: 0, textTransform: 'none' }}
                    >
                        {label}
                    </Button>
                ))}
            </div>
            <AceEditor
                placeholder="Enter MJML components here..."
                mode="xml"
                theme="monokai"
                name={`mjml-editor-${id}`}
                onLoad={onLoad}
                onChange={onChange}
                fontSize={13}
                showPrintMargin={false}
                showGutter={true}
                highlightActiveLine={true}
                value={mjml}
                wrapEnabled={true}
                setOptions={{
                    enableBasicAutocompletion: true,
                    enableLiveAutocompletion: true,
                    enableSnippets: false,
                    showLineNumbers: true,
                    tabSize: 2,
                    useWorker: false,
                }}
            />
        </div>
    );
};

export default MjmlEditor;
